import { render, staticRenderFns } from "./AnNoteOpen.vue?vue&type=template&id=badc2608&scoped=true&"
import script from "./AnNoteOpen.vue?vue&type=script&lang=js&"
export * from "./AnNoteOpen.vue?vue&type=script&lang=js&"
import style0 from "./AnNoteOpen.vue?vue&type=style&index=0&id=badc2608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badc2608",
  null
  
)

export default component.exports